/*
 * Auth
 * @module features/App
 * @flow weak
 */

import { compose, withPropsOnChange, mapProps } from 'recompose';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { parse } from 'query-string';
import localforage from 'localforage';
import * as R from 'ramda';

import { AceService } from '~/services';
import { LOCALES, STORAGE_KEY_REDIRECT_URI } from '~/helpers';
import { LOGGED_IN_USER, UPDATE_LOCALE } from '~/gql';

import { Auth as ATH } from './Auth';

const withLocaleMutation = graphql(UPDATE_LOCALE, {
  name: 'updateLocale',
});

const withLoggedInUser = graphql(LOGGED_IN_USER, {
  alias: 'withLoggedInUser',
  options: {
    fetchPolicy: 'network-only',
    variables: { includeIdToken: true },
  },
  props: ({ data }) => {
    const { loading, loggedInUser } = data;

    if (!loading && !loggedInUser) {
      AceService.signIn();
    }

    return data;
  },
});

const enhance = compose(
  withRouter,
  withLoggedInUser,
  withLocaleMutation,
  withPropsOnChange(
    ['location'],
    async ({ history, location, updateLocale }) => {
      const redirect = await localforage.getItem(STORAGE_KEY_REDIRECT_URI);
      let { search } = location;
      let { locale } = parse(search);
      let pathname = redirect || location.pathname || '/';

      if (redirect) {
        localforage.removeItem(STORAGE_KEY_REDIRECT_URI);
      }

      if (locale) {
        const mappedLocale = R.cond([
          [R.equals('zh'), R.always('zh-CN')],
          [R.T, R.identity],
        ])(locale);

        if (LOCALES.find(({ value }) => value === mappedLocale)) {
          updateLocale({ variables: { locale: mappedLocale } });
        }
      }

      if (search || (redirect && redirect !== location.pathname)) {
        history.replace({ ...location, search: null, pathname });
      }

      return {};
    },
  ),
  mapProps(({ loggedInUser, ...rest }) => ({
    ...loggedInUser,
    ...rest,
  })),
);

export const Auth = enhance(ATH);
